import { memo, useCallback } from "react";
import ResourceLayout from 'ui/layouts/Resource';
import Resource from "ui/widgets/Resource";
import {
    type GridRowParams,
    type GridRowIdGetter,
    GRID_ACTIONS_COLUMN_TYPE,
} from "@mui/x-data-grid-premium";
import { TableGridMode } from "consts/table";
import { FilterVariant } from "consts/filters";
import { multi, text } from "consts/users";
import type { User as UserType } from "features/users/types";
import {
    selectIsUsersLoading,
    selectIsUsersUninitialized,
    selectUserSlice
} from "features/users/selectors";
import useUserRoles from "features/users/useUserRoles";
import { DeleteUser, ToggleActive } from "./UserActions";
import UserToolbar from "./UserToolbar";
import UserCreateEdit from "./UserCreateEdit";
import useUsers from "./useUsers";

const User = () => {
    useUserRoles();

    const getRowId: GridRowIdGetter<UserType> = useCallback(({ coreId }: UserType) =>
        coreId, []);

    return (
        <ResourceLayout
            breadcrumbsProps={{
                heading: 'Users',
                links: [{ name: '' }]
            }}
        >
            <Resource
                name='User'
                useResource={useUsers}
                mode={TableGridMode.User}
                filterTypes={new Map<FilterVariant, string[]>([
                    [FilterVariant.MultiOption, multi],
                    [FilterVariant.Text, text]
                ])}
                selectIsTableUninitialized={selectIsUsersUninitialized}
                selectIsTableLoading={selectIsUsersLoading}
                selectTableDataSlice={selectUserSlice}
                getRowId={getRowId}
                Toolbar={UserToolbar}
                Detail={UserCreateEdit}
                pinnedColumns={{
                    right: [GRID_ACTIONS_COLUMN_TYPE]
                }}
                columns={[
                    {
                        field: GRID_ACTIONS_COLUMN_TYPE,
                        type: GRID_ACTIONS_COLUMN_TYPE,
                        width: 100,
                        maxWidth: 100,
                        getActions: (params: GridRowParams) => [
                            <ToggleActive
                                {...params}
                            />,
                            <DeleteUser
                                {...params}
                            />
                        ]
                    }
                ]}
                LayoutProps={{
                    sx: {
                        mx: 0
                    }
                }}
                FiltersProps={{
                    sx: {
                        mx: 0
                    }
                }}
            />
        </ResourceLayout>
    );
};

export default memo(User);
